class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector(".predictive-search");
    this.predictiveSearchResults.style.display = "none";
    this.searchDelete = this.querySelector(".search__delete");
    this.lupe = this.querySelector(".search__lupe");

    this.input.addEventListener(
      "input",
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );

    this.searchDelete.addEventListener("click", (e) => {
      e.preventDefault();
      this.input.value = "";
      this.close();
    });
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.classList.add("searching");

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    let locale = "";
    if (window.location.pathname.includes("/fr")) {
      locale = "/fr";
    } else if (window.location.pathname.includes("/it")) {
      locale = "/it";
    } else if (window.location.pathname.includes("/en")) {
      locale = "/en";
    } else if (window.location.pathname.includes("/es")) {
      locale = "/es";
    } else if (window.location.pathname.includes("/pl")) {
      locale = "/pl";
    }

    fetch(
      `${window.Shopify.routes.root}search/suggest?q=${searchTerm}&section_id=predictive-search`
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = "flex";
    const lazyImages = document.querySelectorAll(".lazy__img");

    lazyImages.forEach((img) => {
      if (!img.complete) {
        img.addEventListener("load", () => {
          img.classList.remove("lazy__img--loading");
        });
      } else {
        img.classList.remove("lazy__img--loading");
      }
    });
  }

  close() {
    this.predictiveSearchResults.style.display = "none";
    this.classList.remove("searching");
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define("predictive-search", PredictiveSearch);
